import { getIsLoggedInAsync, getCurrentUser } from '@lastbrand/fe-common/universal-auth'

import getCookieDomain from '@src/quince-site-common/src/utils/getCookieDomain'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'
import { logoutUser } from '@src/quince-site-integrated/src/utils'
import { trackWebsiteAction } from '@src/telemetry/integrations/InternalAnalytics'

import { getCookieStorage } from './enhancedCookie'

export const validateUserAuth = async () => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  try {
    const isLoggedIn = await getIsLoggedInAsync()

    if (isLoggedIn) {
      await getCurrentUser(true)
    }
  } catch (error) {
    trackWebsiteAction({
      actionName: 'unauthorized_user_detected',
    })
    const params = new URLSearchParams(location.search)
    const resetPassword = isBrowser() && params.get('reset-password')
    const isInResetPasswordFlow = resetPassword === 'true'
    void logoutUser(false, !isInResetPasswordFlow, isInResetPasswordFlow)
  }
}

export const removeAndSetNewCookies = (key: string, value: string) => {
  getCookieStorage().removeCookieLocalized(key, { isGlobal: true, domain: getCookieDomain() })
  getCookieStorage().setCookieLocalized(key, value, { isGlobal: true })
}
